module.exports = " <cpheader></cpheader> <div id=content style=\"padding: 35px 0 0 0\"> <div class=container> <cp-menu></cp-menu> <div class=page-content-wrapper> <div class=page-content> <div class=col-md-12> <div class=row> <router-view></router-view> </div> </div> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 186
// module chunks = 0